import React from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import {
  Contents,
  ContentsHeader,
  Player,
  Row,
  List,
  ListItem,
  Empty
} from './styled';

const BasketballMatchSelectionTable = observer(({ data }) => {
  const ulHeight = useMemo(() => {
    if (data.length > 0) {
      return 36 * data.length;
    } else {
      return 36;
    }
  }, [data]);

  return (
    <Contents>
      <ContentsHeader>
        <Player>선수명</Player>
        <Row>포지션</Row>
        <Row>득점</Row>
        <Row>어시스트</Row>
        <Row>리바운드</Row>
      </ContentsHeader>
      <List style={{ height: ulHeight }}>
        {data.length > 0 ? (
          data.map((item, idx) => {
            const { points, assists, reboundsTotal, player } = item;

            return (
              <ListItem
                key={`${item.id}${idx}`}
                className={clsx(data.length === idx + 1 && 'noneBorder')}
              >
                <Player>{player.displayName}</Player>
                <Row>{player.position}</Row>
                <Row>{points}</Row>
                <Row>{assists}</Row>
                <Row>{reboundsTotal}</Row>
              </ListItem>
            );
          })
        ) : (
          <Empty>
            <div>라인업 정보가 없습니다.</div>
          </Empty>
        )}
      </List>
    </Contents>
  );
});

export default BasketballMatchSelectionTable;
